// ============================================================
// QuickActionCard Component
// ============================================================
// Clickable card for quick dashboard actions.

import { Box, Typography, ButtonBase } from '@mui/material';
import { tokens } from '@/theme/tokens';
import { useNavigate } from 'react-router-dom';

export function QuickActionCard({ title, icon: Icon, path, color = 'primary' }) {
  const navigate = useNavigate();
  const themeColor = tokens.colors[color]?.main || tokens.colors.primary.main;

  return (
    <ButtonBase
      onClick={() => path && navigate(path)}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        p: 2,
        borderRadius: tokens.radius.md,
        transition: `all ${tokens.transitions.fast}`,
        width: '100%',
        height: '100%',
        '&:hover': {
          bgcolor: `${themeColor}08`,
          transform: 'translateY(-2px)',
        },
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: tokens.radius.full,
          backgroundColor: `${themeColor}12`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: themeColor,
        }}
      >
        <Icon size={24} />
      </Box>
      <Typography variant="subtitle2" fontWeight={600} align="center">
        {title}
      </Typography>
    </ButtonBase>
  );
}
